import script from "./activityAllMarketing.vue?vue&type=script&setup=true&lang=js"
export * from "./activityAllMarketing.vue?vue&type=script&setup=true&lang=js"

import "./activityAllMarketing.vue?vue&type=style&index=0&id=6f5e17fa&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/web-h5-hade/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f5e17fa"]])

export default __exports__